export default "__VITE_ASSET__7422deb2__"